import {RegisterType} from '../component-registry';
import {GuidedUiPopularQueries} from '../../models/Guided.schema';
import {GuidedQuickLinkDetails} from '../../models/quick-link';
import {onlyMatchingSource} from '../../utils';
import {mapGuidedV2ItemToGuidedV2KeywordSuggestions} from '../mappers';
import {SuggestionsBar} from '../suggestions/guided-suggestions';
import {h} from '@stencil/core';
import type {GuidedV2FactoryState} from '../../models/ui';

export class GuidedV2PopularQueries {
  /**
   * Shows the popular queries in the guided search. Keywords shown before user
   * has typed anything in the search box. The same searcher as in the Seyword Suggestions
   * but with "*" as query
   * @param inputData
   * @param state
   */
  @RegisterType(GuidedUiPopularQueries.type)
  render<T extends GuidedQuickLinkDetails>(
    inputData: GuidedUiPopularQueries,
    state: GuidedV2FactoryState<T>,
  ) {
      const {
        itemSources,
        label,
        maxItems,
      } = inputData; //comes from configuration

      const {
        labelProvider,
        eventEmitters,
        results, //the API response
      } = state;

      const matchingResults = results
        .filter(onlyMatchingSource(itemSources))
        .slice(0, maxItems)
        .map(mapGuidedV2ItemToGuidedV2KeywordSuggestions)
    ;

      if (matchingResults.length == 0)
        return <span data-err="Popular queries list is empty"></span>;

      const suggestionsLabel = labelProvider(
        `GuidedV2.popular-queries.label.${label}`, //TODO: labelProvider kluczyki
        label
      );

      return <div class="guided-v2-popular-queries"><SuggestionsBar
        results={matchingResults}
        label={suggestionsLabel}
        eventEmitters={eventEmitters}
      /></div>;
  }
}
